import { Injectable } from '@angular/core';
import { Benachrichtigung } from '@karl/entities';
import { FormatNumberPipe } from '../pipe/format-number-pipe';

@Injectable()
export class NotificationsUtil {
  public static formatNumberPipe = new FormatNumberPipe();

  public static getHeadline(benachrichtigung: Benachrichtigung): string {
    if (benachrichtigung) {
      switch (benachrichtigung.typ) {
        case 'doc':
          return benachrichtigung.bezeichnung ? benachrichtigung.bezeichnung : 'Neues Dokument';
        case 'zahl':
          return 'Neue Zahlung';
      }
    }
    return '';
  }

  public static getText(benachrichtigung: Benachrichtigung): NotificationText {
    if (benachrichtigung) {
      switch (benachrichtigung.typ) {
        case 'doc':
          if (!benachrichtigung.schadenNr) {
            return {
              preText:
                'Es ist ein neues Dokument zu ' +
                this.formatNumberPipe.transform(benachrichtigung.polizzenNr, 'polizze') +
                ' - ',
              contextText:  benachrichtigung.marketingBezeichnung.text,
              elevatedText: benachrichtigung.marketingBezeichnung.hochgestellt,
              postText:     ' verfügbar.'
            };
          } else {
            return {
              preText: 'Es ist ein neues Dokument zu Ihrem Schaden ',
              contextText:
                       this.formatNumberPipe.transform(benachrichtigung.schadenNr, 'schaden') +
                         (benachrichtigung.sparte ? ' in der Sparte ' + benachrichtigung.sparte : '') +
                         ' verfügbar.'
            };
          }
        case 'zahl':
          return {
            preText: 'Zu Ihrem Schaden ',
            contextText:
                     this.formatNumberPipe.transform(benachrichtigung.schadenNr, 'schaden') +
                       (benachrichtigung.sparte ? ' in der Sparte ' + benachrichtigung.sparte : '') +
                       ' wurde eine Zahlung geleistet.'
          };
      }
    }
    return {};
  }

  public static getIcon(benachrichtigung: Benachrichtigung): string {
    if (benachrichtigung) {
      switch (benachrichtigung.typ) {
        case 'doc':
          return 'description';
        case 'zahl':
          return 'payment';
      }
    }
    return '';
  }

  public static getNotificationText(ntfc: Benachrichtigung): string {
    const text = NotificationsUtil.getText(ntfc);
    if (text) {
      return (text.preText ? text.preText : '') + (text.contextText ? text.contextText : '') + (text.elevatedText ? ' ' + text.elevatedText : '') + (text.postText ? text.postText : '');
    }
    return '-';
  }

  public static getUnreadNotificationText(count: number): string {
    if (count) {
      return count > 1 ? (count + ' ungelesene Nachrichten') : '1 ungelesene Nachricht';
    }
    return 'Keine ungelesenen Nachrichten';
  }

}

export class NotificationText {
  public preText?: string;
  public contextText?: string;
  public postText?: string;
  public elevatedText?: string;
}
